import { render, staticRenderFns } from "./ScientistTermResult.vue?vue&type=template&id=142342ff&scoped=true&"
import script from "./ScientistTermResult.vue?vue&type=script&lang=js&"
export * from "./ScientistTermResult.vue?vue&type=script&lang=js&"
import style0 from "./ScientistTermResult.vue?vue&type=style&index=0&id=142342ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142342ff",
  null
  
)

export default component.exports